document.addEventListener("DOMContentLoaded", function () {
  const thumbnailSliderSelector = '.thumbnails-slider';
  const thumbnailSliderEl = document.querySelector(thumbnailSliderSelector);
  const fullscreenZoomClass = 'main-product-slider__container--image-zoomed';

  function getThumbnailSlides() {
    return Array.from(
      thumbnailSliderEl?.querySelectorAll('.swiper-slide') || []
    );
  }

  function getSlidesPerView(swiper) {
    if (!swiper) return 1;

    let slidesPerView = swiper.params.slidesPerView;
    const breakpointEntries = Object.entries(swiper.params.breakpoints || {})
      .map(([width, params]) => [Number(width), params])
      .filter(([width]) => !Number.isNaN(width))
      .sort((a, b) => a[0] - b[0]);

    breakpointEntries.forEach(([width, params]) => {
      if (window.innerWidth >= width && params.slidesPerView) {
        slidesPerView = params.slidesPerView;
      }
    });

    return Number(slidesPerView) || 1;
  }

  function syncThumbnailBalance(swiper) {
    if (!swiper || !swiper.el) return;

    const visibleSlots = getSlidesPerView(swiper);
    const slideCount = swiper.slides.length;
    swiper.el.classList.toggle('thumbnails-slider--balanced', slideCount <= visibleSlots);
  }

  function syncActiveThumbnail() {
    const slides = getThumbnailSlides();
    slides.forEach((slide, index) => {
      slide.classList.toggle('is-active', index === mainSlider.realIndex);
    });
  }

  function getFullscreenContainer() {
    return document.querySelector('.main-product-slider__container');
  }

  function clearImageZoom() {
    const container = getFullscreenContainer();
    if (!container) return;

    container.classList.remove(fullscreenZoomClass);
    container.querySelectorAll('.main-product-slider .swiper-slide').forEach((slide) => {
      slide.classList.remove('is-image-zoomed');
      slide.style.removeProperty('--zoom-origin-x');
      slide.style.removeProperty('--zoom-origin-y');
      slide.style.removeProperty('--zoom-scale');
    });
  }

  function toggleImageZoom(event) {
    const container = getFullscreenContainer();
    if (!container || !container.classList.contains('fullscreen')) {
      return false;
    }

    const activeSlide = container.querySelector('.main-product-slider .swiper-slide-active');
    const activeImage = activeSlide?.querySelector('img');
    if (!activeSlide || !activeImage) return false;

    const imageRect = activeImage.getBoundingClientRect();
    const naturalWidth = activeImage.naturalWidth || 0;
    const naturalHeight = activeImage.naturalHeight || 0;

    if (
      !naturalWidth ||
      !naturalHeight ||
      (naturalWidth <= imageRect.width && naturalHeight <= imageRect.height)
    ) {
      return false;
    }

    const alreadyZoomed = activeSlide.classList.contains('is-image-zoomed');

    if (alreadyZoomed) {
      clearImageZoom();
      return true;
    }

    const originX = ((event.clientX - imageRect.left) / imageRect.width) * 100;
    const originY = ((event.clientY - imageRect.top) / imageRect.height) * 100;
    const scale = Math.min(
      2.6,
      Math.max(
        1.35,
        Math.min(naturalWidth / imageRect.width, naturalHeight / imageRect.height)
      )
    );

    clearImageZoom();
    container.classList.add(fullscreenZoomClass);
    activeSlide.classList.add('is-image-zoomed');
    activeSlide.style.setProperty('--zoom-origin-x', `${originX}%`);
    activeSlide.style.setProperty('--zoom-origin-y', `${originY}%`);
    activeSlide.style.setProperty('--zoom-scale', scale.toFixed(2));
    return true;
  }

  const mainSlider = new Swiper('.main-product-slider', {
    loop: true,
    roundLengths: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });

  // Expose for debugging if you want
  window.mainProductSwiper = mainSlider;

  const thumbnailsSlider = new Swiper(thumbnailSliderSelector, {
    spaceBetween: 15,
    slidesPerView: 4,
    freeMode: true,
    watchOverflow: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    breakpoints: {
      1280: {
        slidesPerView: 6
      }
    }
  });

  syncThumbnailBalance(thumbnailsSlider);
  syncActiveThumbnail();

  // Thumbnail click controls main slider
  if (thumbnailSliderEl) {
    thumbnailSliderEl.addEventListener('click', function (event) {
      const clickedSlide = event.target.closest('.swiper-slide');
      if (clickedSlide) {
        const slides = getThumbnailSlides();
        const clickedIndex = slides.indexOf(clickedSlide);
        if (clickedIndex < 0) return;

        mainSlider.slideToLoop(clickedIndex, 500, true);
      }
    });
  }

  // Refresh Swiper sizing after images load (avoids messy thumbnails on first paint)
  function refreshSwipers() {
    mainSlider.update();
    mainSlider.updateSize();
    mainSlider.updateSlides();

    thumbnailsSlider.update();
    thumbnailsSlider.updateSize();
    thumbnailsSlider.updateSlides();

    if (mainSlider.params.loop) {
      mainSlider.loopFix();
    }

    syncThumbnailBalance(thumbnailsSlider);
    syncActiveThumbnail();
  }

  const images = document.querySelectorAll(
    '.main-product-slider img, .thumbnails-slider img'
  );

  let pending = images.length;

  if (pending === 0) {
    refreshSwipers();
  } else {
    images.forEach(img => {
      if (img.complete) {
        pending -= 1;
        if (pending === 0) refreshSwipers();
      } else {
        img.addEventListener('load', () => {
          pending -= 1;
          if (pending === 0) refreshSwipers();
        }, { once: true });

        img.addEventListener('error', () => {
          pending -= 1;
          if (pending === 0) refreshSwipers();
        }, { once: true });
      }
    });

    // Safety net in case an image never fires load/error for any reason
    setTimeout(refreshSwipers, 750);
  }

  // Fullscreen toggle
  function toggleFullscreen() {
    const container = getFullscreenContainer();
    if (!container) return;
    if (container.classList.contains('fullscreen')) {
      clearImageZoom();
    }
    container.classList.toggle('fullscreen');

    // When switching modes, force Swiper to recalc sizes
    // (especially important because you change widths/heights in fullscreen CSS)
    refreshSwipers();
  }

  // Enter fullscreen when main slider is clicked
  mainSlider.on('click', function (swiper, event) {
    const container = getFullscreenContainer();
    if (container?.classList.contains('fullscreen')) {
      if (toggleImageZoom(event)) {
        return;
      }
    }

    toggleFullscreen();
  });

  mainSlider.on('slideChange', function () {
    clearImageZoom();
    syncActiveThumbnail();
  });

  // Exit fullscreen button
  const exitBtn = document.querySelector('.exit-fullscreen-btn');
  if (exitBtn) {
    exitBtn.addEventListener('click', function (e) {
      e.stopPropagation(); // prevent bubbling to slider click
      toggleFullscreen();
    });
  }

  window.addEventListener('resize', function () {
    syncThumbnailBalance(thumbnailsSlider);
  });

});
